import { actionGenerator, IReduxAction } from '../../utils/actions';
import { EMoneySource } from '../../types/reducers/user';

export const SET_PLACING_MONEY_SOURCE = 'PUBLISH_TERMS :: PLACING_MONEY_SOURCE :: SET';

export type TSetPlacingMoneySource = IReduxAction<typeof SET_PLACING_MONEY_SOURCE, EMoneySource>;

export const setPlacingMoneySource = actionGenerator<typeof SET_PLACING_MONEY_SOURCE, EMoneySource>(
  SET_PLACING_MONEY_SOURCE,
);
